type ProcedureMeta = {
  name: string
  codeSystemUrl: string
  valueSetUrl: string
}

export function buildProcedureMeta(organizationId: string): ProcedureMeta {
  const name = `behuman-procedures-${organizationId}`
  return {
    name,
    codeSystemUrl: `https://behuman.health/fhir/CodeSystem/${name}`,
    valueSetUrl: `https://behuman.health/fhir/ValueSet/${name}`,
  }
}
